module.exports = __webpack_public_path__ + "img/20190629102719QQ截图20190624162241.0e369ff3.png";